import { render } from "./PageViewPage.vue?vue&type=template&id=a1e20070&scoped=true"
import script from "./PageViewPage.vue?vue&type=script&lang=js"
export * from "./PageViewPage.vue?vue&type=script&lang=js"

import "./PageViewPage.vue?vue&type=style&index=0&id=a1e20070&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a1e20070"

export default script